import { render, staticRenderFns } from "./ProcesoCompetitivo.vue?vue&type=template&id=2b890275&scoped=true"
import script from "./ProcesoCompetitivo.vue?vue&type=script&lang=js"
export * from "./ProcesoCompetitivo.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompetitivo.vue?vue&type=style&index=0&id=2b890275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b890275",
  null
  
)

export default component.exports